<template>
  <div class="right-tag" :class="`right-tag-${rightsType} right-tag-${size ?? 'medium'}`">
    {{ rightsTypeName }}
  </div>
</template>

<script setup lang="ts">
import { useEnumDictionary } from '@rendora/common/composables/useEnumDictionary';
import { IRightsType } from '@rendora/common/types/enums';
import { computed } from 'vue';

const props = defineProps<{
  rightsType: IRightsType;
  size?: 'small' | 'medium';
}>();

const rightsTypeMap = useEnumDictionary('rights_type');

const rightsTypeName = computed(() => {
  if (props.rightsType === undefined || props.rightsType === null) return '';
  return rightsTypeMap[props.rightsType] || '';
});
</script>

<style scoped lang="scss">
@use '@rendora/design/styles/mixins.scss' as *;

.right-tag {
  font-size: var(--x-text-12-size);
  line-height: var(--x-text-12-line-height);
  padding: 7px 8px;
  border-radius: var(--x-radius-medium);
  text-align: center;

  @include mobile() {
    padding: responsive-size(7px) responsive-size(8px);
  }
}

.right-tag-small {
  border-radius: 100px;
  padding: 4px 10px;

  @include mobile() {
    border-radius: responsive-size(100px);
    padding: responsive-size(4px) responsive-size(10px);
  }
}

.right-tag-1,
.right-tag-15 {
  background-color: var(--x-back-3);
  color: var(--x-text-3);
}
.right-tag-3 {
  background-color: #9995ff;
  color: #fff;
}
.right-tag-10 {
  background-color: #9364ff;
  color: #fff;
}
.right-tag-16 {
  background-color: var(--x-warning-3);
  color: var(--x-warning-9);
}
.right-tag-21 {
  background-color: var(--x-warning-9);
  color: var(--x-warning-1);
}
.right-tag-22 {
  background-color: var(--x-warning-10);
  color: var(--x-warning-3);
}
</style>
